import { Box, LinearProgress } from '@mui/material';
import { useOnline } from 'base-shell/lib/providers/Online';
import { useEffect } from 'react';

import CustomAppbar from './CustomAppbar';
import OfflineMessage from './OfflineMessage';

import IntlMessage from 'components/IntlMessage';
import TitleBox from 'components/TitleBox';
import { setBodyHeight } from './method';
import { PageContentStyle, PageStyle } from './style';

export default function Page({
  children,
  pageTitle,
  onBackClick,
  enableMenu = false,
  enableCart = false,
  isLoading,
  appBarContent = null,
  contentStyle,
  isAppBarVisible = false,
  appbar = null,
  toolbar = null,
  sx = {},
  pageRef = null,
  title,
  titleId,
}) {
  const isOnline = useOnline();
  const label = title || <IntlMessage id={titleId} />;

  useEffect(() => {
    setBodyHeight();
    window.addEventListener('resize', setBodyHeight);
    return () => window.removeEventListener('resize', setBodyHeight);
  }, []);

  return (
    <Box
      sx={{ ...PageStyle, ...sx, backgroundColor: 'rgba(235, 235, 235, 1)' }}
      ref={pageRef}
    >
      {!isOnline && <OfflineMessage />}
      {isLoading && <LinearProgress />}

      {/* <Box sx={BottomLineGradientStyle}></Box> */}
      {isAppBarVisible &&
        (appbar ? (
          appbar
        ) : (
          <CustomAppbar
            {...{
              pageTitle,
              appBarContent,
              onBackClick,
              enableCart,
              enableMenu,
            }}
          />
        ))}
      {title || titleId ? <TitleBox title={label} /> : null}
      {/* {isAppBarVisible && <Box sx={PageAppBarVisible(appbarHeight)} />} */}
      <Box sx={PageContentStyle(contentStyle)}>{children}</Box>
      {toolbar && toolbar}
    </Box>
  );
}
